module.exports = {"pathContext":{"name":"PatientLocationInput","kind":"INPUT_OBJECT","type":"OBJECT","fields":[{"defaultValue":null,"description":null,"name":"kennelId","type":{"kind":"SCALAR","name":"ID","ofType":null}},{"defaultValue":null,"description":null,"name":"wardId","type":{"kind":"SCALAR","name":"ID","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/input-object-patient-location-input.json
// module id = 1495
// module chunks = 54192777934211